import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { colors } from "../../../app/theme/colors";
import AppButton from "../../../components/appButton/appButton";
import { useAppDispatch } from "../../../app/redux/hooks";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import logo from "../../../images/logoFull.png";
import CustomOutlinedInput from "../../../components/outlinedInput/customOutlinedInput";
import { useForgotPasswordModalStyles } from "./forgotPasswordModalStyles";
import ForgotSetPasswordModal from "./forgotSetPasswordModal";

interface Props {
  open: any;
  handleClose: any;
}

export default function ForgotPasswordModal({ handleClose, open }: Props) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { classes } = useForgotPasswordModalStyles();
  const theme = useTheme();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [isOpenForgotSetPassword, setIsOpenForgotSetPassword] =
    useState<boolean>(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailError(false);
  };

  const handleLogin = () => {
    setIsOpenForgotSetPassword(true);
  };

  const handleDialogClose = () => {
    setEmailError(false);
    setPasswordError(false);

    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth="xs"
      id="forgotPassword_dialog"
      PaperProps={{ sx: { borderRadius: "15px", overflow: "hidden" } }}
    >
      <IconButton
        edge="end"
        color="inherit"
        onClick={handleDialogClose}
        aria-label="close"
        sx={{
          position: "absolute",
          top: theme.spacing(1),
          right: theme.spacing(2),
        }}
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
      <DialogContent className={classes.dialogContent}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          padding={"5px"}
          sx={{ textAlign: "center" }}
        >
          <Grid item md={12} xs={12}>
            <img
              src={logo}
              alt="Logo"
              className={classes.logoImage}
              id="forgotPassword_img_logo"
            />
          </Grid>
          <Grid item md={12} xs={12} mt={5}>
            <Typography variant="h4" className={classes.title}>
              {t("forgotPasswordModal.forgotPasswordTitle")}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12} mt={5}>
            <CustomOutlinedInput
              id="forgotPassword_input_email"
              type="email"
              label={t("loginModal.loginEmail")}
              width="100%"
              labelColor={colors.primary}
              onChange={handleEmailChange}
              value={email}
              error={emailError}
              errorMessage={t("loginModal.loginErrorEmail")}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <AppButton
          id="forgotPassword_button_close"
          onClick={handleLogin}
          color={colors.primary}
          hover={colors.primary}
          label={t("buttons.login")}
          width="100%"
        />
      </DialogActions>
      <ForgotSetPasswordModal
        handleClose={() => setIsOpenForgotSetPassword(false)}
        open={isOpenForgotSetPassword}
      />
    </Dialog>
  );
}
